import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=4b2eb24e&scoped=true&"
import script from "./EditAccount.vue?vue&type=script&lang=js&"
export * from "./EditAccount.vue?vue&type=script&lang=js&"
import style0 from "./EditAccount.vue?vue&type=style&index=0&id=4b2eb24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2eb24e",
  null
  
)

export default component.exports